import React from 'react';

import { UiKit } from 'components';
import { TableHeading, TableAddButton } from 'components/Tables';
import {
  AccountDetails,
  StoresTable,
  UserDetails,
  ConnectionRedirect
} from './containers';
import { useSegmentPageCapture, useStoreConnect } from 'utils/hooks';

export default function AccountSettings() {
  useSegmentPageCapture('Account Settings');

  const { onOpen } = useStoreConnect();

  return (
    <>
      <TableHeading
        title="Account Settings"
        helpText="Set up your Exchange Catalog defaults. Select product types and collections, or exclude products by tags or price."
        customClass="animated fadeIn"
      >
        <TableAddButton onClick={() => onOpen()}>
          Connect New Store
        </TableAddButton>
      </TableHeading>
      <UiKit.Grid templateColumns="1fr" gap="24">
        <UiKit.Grid templateColumns="1fr 2fr" gap="24">
          <AccountDetails />
          <UserDetails />
        </UiKit.Grid>
        <StoresTable />
      </UiKit.Grid>
      <ConnectionRedirect />
    </>
  );
}
